 
import { Injectable, NgModule } from '@angular/core';
import {
  RouterModule,
  RouterStateSnapshot,
  Routes,
  TitleStrategy,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { HelpLinksComponent } from '../modules/dashboard/components/help-links/help-links.component';
import { WaitListComponent } from '../modules/dashboard/components/wait-list/wait-list.component';
import { NotificationComponent } from '../modules/dashboard/components/notification/notification.component';
import { IhmsActionItemsComponent } from '../modules/dashboard/components/ihms-action-items/ihms-action-items.component';
import { ParentalConsentFormComponent } from '../modules/dashboard/components/parental-consent-form/parental-consent-form.component';

@Injectable({ providedIn: 'root' })
export class TemplatePageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title: string | undefined = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`ATLAS | ${title}`);
    }
  }
}

const routes: Routes = [
  // {
  //   path: 'security',
  //   loadChildren: () => import('../modules/security/security.module').then(m => m.SecurityModule)
  // },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'student',
    loadChildren: () =>
      import('../modules/student-profile/student-profile.module').then(
        (m) => m.StudentProfileModule
      ),
    // canActivate: [AuthGuard, canActivateStudentProfile]
  },
  {
    path: 'location',
    loadChildren: () =>
      import('../modules/location-profile/location-profile.module').then(
        (m) => m.LocationProfileModule
      ),
    // canActivate: [AuthGuard, canActivateStudentProfile]
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('../modules/report/report.module').then((m) => m.ReportModule),
    // canActivate: [AuthGuard, canActivateStudentProfile]
  },
  {
    path: 'my-messages',
    loadChildren: () =>
      import('../modules/my-messages/my-messages.module').then(
        (m) => m.MyMessagesModule
      ),
  },
  {
    path: 'permissions',
    loadChildren: () =>
      import('../modules/permissions/permissions.module').then(
        (m) => m.PermissionsModule
      ),
  },

  {
    path: 'student-search',
    loadChildren: () =>
      import('../modules/student-search/student-search.module').then(
        (m) => m.StudentSearchModule
      ),
    // canActivate: [AuthGuard, canActivateStudentProfile]
  },
  {
    path: 'referrals',
    loadChildren: () =>
      import('../modules/referrals/referrals.module').then(
        (m) => m.ReferralsModule
      ),
    // canActivate: [AuthGuard, canActivateReferrals]
  },
  {
    path: 'ei',
    loadChildren: () =>
      import('../modules/ei-transition/ei-transition.module').then(
        (m) => m.EiTransitionModule
      ),
    // canActivate: [AuthGuard, canActivateEiTransition]
  },
  {
    path: 'evaluations',
    loadChildren: () =>
      import('../modules/evaluations/evaluations.module').then(
        (m) => m.EvaluationsModule
      ),
    // canActivate: [AuthGuard, canActivateEvaluations]
  },
  {
    path: 'iep',
    loadChildren: () =>
      import('../modules/iep/iep.module').then((m) => m.IEPModule),
    // canActivate: [AuthGuard, canActivateIEP]
  },
  {
    path: 'CBST',
    loadChildren: () =>
      import('../modules/cbst/cbst.module').then((m) => m.CbstModule),
    // canActivate: [AuthGuard, canActivateIEP]
  },
  {
    path: 'placement',
    loadChildren: () =>
      import('../modules/placement/placement.module').then(
        (m) => m.PlacementModule
      ),
    //canActivate: [AuthGuard, canActivateIEP]
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('../modules/caseload/caseload.module').then(
        (m) => m.CaseloadModule
      ),
    //canActivate: [AuthGuard, canActivateIEP]
  },
  {
    path: 'verification',
    loadChildren: () =>
      import(
        '../modules/verification-guardian-parent-child/verification-guardian-parent-child.module'
      ).then((m) => m.VerificationGuardianParentChildModule),
    //canActivate: [AuthGuard, canActivateVerification]
  },
  {
    path: 'search',
    loadChildren: () =>
      import('../modules/search/search.module').then((m) => m.SearchModule),
    //canActivate: [AuthGuard, canActivateVerification]
  },
  {
    path: 'nursing-referral',
    loadChildren: () =>
      import('../modules/nursing-referral/nursing-referral.module').then(
        (m) => m.NursingReferralModule
      ),
  },
  {
    path: 'help-links',
    component: HelpLinksComponent,
    pathMatch: 'full',
  },
  {
    path: 'all-notifications',
    component: NotificationComponent,
    pathMatch: 'full',
  },
  {
    path: 'wait-list/:type/:id',
    component: WaitListComponent,
    pathMatch: 'full',
  },
  {
    path: 'wait-list/:type',
    component: WaitListComponent,
    pathMatch: 'full',
  },
  {
    path: 'parental-consent-form',
    component: ParentalConsentFormComponent,
    pathMatch: 'full',

  },
  {
    path: 'ihms-action-items',
    component: IhmsActionItemsComponent,
    pathMatch: 'full',
  },
  {
    path: 'admin/agency-mde',
    loadChildren: () =>
      import('../modules/administration/administration.module').then(
        (m) => m.AdministrationModule
      ),
    //canActivate: [AuthGuard, canActivateIEP]
  },
  {
    path: 'kip',
    loadChildren: () =>
      import('../modules/kip-landing/kip-landing.module').then(
        (m) => m.KipLandingModule
      ),
  },
  {
    path: 'provider-management',
    loadChildren: () =>
      import('../modules/provider-management/provider-management.module').then(
        (m) => m.ProviderManagementModule
      ),
  },
  {
    path: 'related-service/:iepSK/:providerSK/:action',
    loadChildren: () =>
      import('../modules/related-service/related-service.module').then(
        (m) => m.RelatedServiceModule
      ),
  },
 {
    path: 'medical-transportation-accommodation',
    loadChildren: () =>
      import('../modules/medical-transportation-accommodation/medical-transportation-accommodation.module').then(
        (m) => m.MedicalTransportationAccommodationModule
      ),
  },
  {
    path: 'clusters',
    loadChildren: () =>
      import('../modules/clusters/clusters.module').then(
        (m) => m.ClustersModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RoutesRoutingModule { }
